module.exports = __webpack_public_path__ + "img/logo-canada-mapple-only-light.494a0113.svg";